import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Grid,
  Icon,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

class PlannerUpgrade extends Component {
  constructor(props) {
    super(props)

  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        <Grid item xs={12} md={8} className={classes.bottomBar}>
          <Button onClick={() => this.props.history.push('/pricing')} variant="contained" color="primary" size="large" className={classes.buttonBook}>
            <Fragment>Upgrade<Icon className="material-icons-outlined notranslate" style={{marginLeft: 10, marginBottom: -7}}>east</Icon></Fragment>
          </Button>
        </Grid>
      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {},
  gridFilters: {},
  headlinePaper: {},
  headline: {},
  subtitle: {},
  listItemIcon: {},
  listItemText: {},
  listItemTextSecondary: {},
  listItemTextPrice: {},
  listItemSelected: {},
  listItem: {},
  buttonBook: {},
  bottomBar: {},
  buttonOutlined: {},
  buttonOutlinedSelected: {},
})

export default withRouter(withStyles(styles)(PlannerUpgrade))
